import React, { useState } from 'react';
import TextType from './types/Text';
import CheckboxType from './types/Checkbox';
import NumberType from './types/Number';
import PhotoType from './types/Photo';
import MultiOptionType from './types/Multioption';
import BarcodeType from './types/Barcode';
import { ChecklistType, QuizQuestionStatus } from '../../../globals';
import Spacer from '../../layout/Spacer';
import { useTypedSelector } from '../../../state/hooks';
import { ChecklistItem } from '../../../interfaces/checklistItem';

interface IChecklistPreviewItemProps
{
	item: ChecklistItem;
	pointerEvents: string;
	onChangeCallback?: (index: number, value: any) => void;
	isQuiz: boolean;
	questionStatus: QuizQuestionStatus;
	index: number;
	id: string;
}

export default function ChecklistPreviewItem(props: IChecklistPreviewItemProps)
{
	const sessionInfo = useTypedSelector(state => state.userModule.sessionInfo);
	
	const [answerInfo, setAnswerInfo] = useState<{ date: string, username: string } | null>(null);

	const item = props.item;
	const pointerEvents = props.pointerEvents ? props.pointerEvents : 'none';

	const responseType = (() =>
	{
		switch(item.type)
		{
			case ChecklistType.TEXT:
				return <TextType pointerEvents={pointerEvents}
					prefill={item.prefill}
					onChangeCallback={
						(v)=>{if(props.onChangeCallback) onChangeCallback(0, v)}
					}
				/>;
			case ChecklistType.CHECKBOX:
				return <CheckboxType pointerEvents={pointerEvents}
					prefill={item.prefill}
					onChangeCallback={
						(v)=>{if(props.onChangeCallback) onChangeCallback(0, v)}
					}
				/>;
			case ChecklistType.NUMBER:
				return <NumberType pointerEvents={pointerEvents}
					prefill={item.prefill}
					onChangeCallback={
						(v)=>{if(props.onChangeCallback) onChangeCallback(0, v)}
					}
				/>;
			case ChecklistType.PHOTO:
				return <PhotoType pointerEvents={pointerEvents}
					onChangeCallback={
						(v)=>{if(props.onChangeCallback) onChangeCallback(0, v)}
					}
				/>;
			case ChecklistType.MULTI_OPTION:
				return <MultiOptionType {...props} options={item.options} pointerEvents={pointerEvents} 
					onChangeCallback={
						(i, v)=>{if(props.onChangeCallback) onChangeCallback(i, v)}
					}
				/>;
			case ChecklistType.MULTI_OPTION_SELECT:
				return <MultiOptionType {...props} options={item.options} pointerEvents={pointerEvents} 
					onChangeCallback={
						(i, v)=>{if(props.onChangeCallback) onChangeCallback(i, v)}
					}
				/>;   
			case ChecklistType.MULTI_OPTION_3D:
				return <MultiOptionType {...props} options={item.options} pointerEvents={pointerEvents} 
					onChangeCallback={
						(i, v)=>{if(props.onChangeCallback) onChangeCallback(i, v)}
					}
				/>;
			case ChecklistType.MULTI_OPTION_SELECT_3D:
				return <MultiOptionType {...props} options={item.options} pointerEvents={pointerEvents} 
					onChangeCallback={
						(i, v)=>{if(props.onChangeCallback) onChangeCallback(i, v)}
					}
				/>;  
			case ChecklistType.BARCODE:
				return <BarcodeType pointerEvents={pointerEvents}
					onChangeCallback={
						(v)=>{if(props.onChangeCallback) onChangeCallback(0, v)}
					}
				/>;
		}
	})();

	function formMustResponedAnswered()
	{
		if(props.isQuiz || !props.item.mustRespond) 
		{
			return true;
		}

		return answerInfo !== null;
	}

	function onChangeCallback(index: number, value: any)
	{
		if(!value)
		{
			setAnswerInfo(null);
		}
		else 
		{
			setAnswerInfo({ date: new Date(Date.now()).toLocaleDateString(), username: sessionInfo?.name || "" });
		}
        
		props.onChangeCallback?.(index, value);
	}

	function getQuestionInstructions()
	{
		if(props.questionStatus !== QuizQuestionStatus.UNANSWERED) 
		{
			return "Your Answers";
		}

		switch(props.item.type)
		{
			case ChecklistType.MULTI_OPTION:
				return ""; //"Select the correct answer";
			case ChecklistType.MULTI_OPTION_SELECT:
				return "Select all that apply";
			case ChecklistType.MULTI_OPTION_3D:
				return "Tap an object to select it";
			case ChecklistType.MULTI_OPTION_SELECT_3D:
				return "Tap an object to select it. Select all that apply";
		}
	}

	//render
	return (
		<div style={{ textAlign:"center", marginBottom:"5px", marginLeft:'14px', marginTop:'12px' }}>
			<div data-name={'checklist-preview-item-'+props.index}>
				<div style={{ textAlign:"left", fontSize:'22px', color: formMustResponedAnswered() ? "" : "#EB5757" }}>
					{ !formMustResponedAnswered() ? `* ${item.description}` : item.description}
				</div>
				<Spacer size={{ y:'12px' }}/>
				{
					props.isQuiz && 
						<div style={{ textAlign:"left" }}>
							<span style={{ color:'gray' }}>{getQuestionInstructions()}</span>
							<Spacer size={{ y:'15px' }}/>
						</div>
				}
				<div style={{ textAlign:"center", marginTop:"0px" }}>
					{responseType}
				</div>
				{
					answerInfo && !props.isQuiz ? 
						<div style={{ textAlign:'left' }}>
							<Spacer size={{ y:'10px' }}/>
							<span style={{ color:'#848484' }}>{`completed on ${answerInfo?.date} by ${answerInfo?.username}`}</span>
						</div> 
					 : <></>
				}
			</div>
		</div>
		
	)
}